import { render, staticRenderFns } from "./GlobalBrands.vue?vue&type=template&id=6a8c2158&"
import script from "./GlobalBrands.vue?vue&type=script&lang=js&"
export * from "./GlobalBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports